import React from 'react';
import classes from './Onboarding.module.scss';

const OnboardingSpotlight = ({
  rect,
  padding = 8,
  borderRadius = 12,
  yOffset = 0,
}) => {
  if (!rect) {
    return <div className={classes.Backdrop} aria-hidden="true" />;
  }

  const x = Math.max(0, rect.left - padding);
  const y = Math.max(0, rect.top - padding - yOffset);
  const width = rect.width + padding * 2;
  const height = rect.height + padding * 2;

  return (
    <svg
      className={classes.SpotlightSvg}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id="onboarding-spotlight-mask">
          <rect width="100%" height="100%" fill="white" />
          <rect
            x={x}
            y={y}
            width={width}
            height={height}
            rx={borderRadius}
            ry={borderRadius}
            fill="black"
          />
        </mask>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill="rgba(0, 0, 0, 0.55)"
        mask="url(#onboarding-spotlight-mask)"
      />
    </svg>
  );
};

export default OnboardingSpotlight;
